import { Api } from './Api';

export function* getLanding1Data(data){
    const jsonData = yield Api.get(`/frogtutoring/landing2021?loc_interest_ms=${data.loc_interest_ms}&loc_physical_ms=${data.loc_physical_ms}&subject=${data.subject}&phone=${data.phone}&city=${data.city}&keyword=${data.keyword}&campaign=${data.campaign}&gclid=${data.gclid}`);
    return jsonData;
}